import { Activity, FlatInteractionModelData } from 'types/shared'
import { CURRENT_GROUP_UUID } from './constants'

export const flatValuesToOldActivities = (
  flatValues: FlatInteractionModelData['activity_values']
): Activity[] => {
  return Object.entries(flatValues).flatMap(([uuid_activity_model, value]) => {
    if (Array.isArray(value)) {
      return {
        uuid_activity_model,
        des: JSON.stringify(
          value.map((group) =>
            flatValuesToOldActivities({
              [CURRENT_GROUP_UUID]: group.uuid,
              ...group.values
            })
          )
        )
      }
    }

    if (typeof value === 'string') {
      return { uuid_activity_model, des: value }
    }

    return { uuid_activity_model, des: value.id, complement: value.des }
  })
}
